"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "article", {
  enumerable: true,
  get: function get() {
    return _article.default;
  }
});
Object.defineProperty(exports, "banner", {
  enumerable: true,
  get: function get() {
    return _banner.default;
  }
});
Object.defineProperty(exports, "blank", {
  enumerable: true,
  get: function get() {
    return _blank.default;
  }
});
Object.defineProperty(exports, "goods", {
  enumerable: true,
  get: function get() {
    return _goods.default;
  }
});
Object.defineProperty(exports, "guide", {
  enumerable: true,
  get: function get() {
    return _guide.default;
  }
});
Object.defineProperty(exports, "image", {
  enumerable: true,
  get: function get() {
    return _image.default;
  }
});
Object.defineProperty(exports, "navBar", {
  enumerable: true,
  get: function get() {
    return _navBar.default;
  }
});
Object.defineProperty(exports, "notice", {
  enumerable: true,
  get: function get() {
    return _notice.default;
  }
});
Object.defineProperty(exports, "richText", {
  enumerable: true,
  get: function get() {
    return _richText.default;
  }
});
Object.defineProperty(exports, "search", {
  enumerable: true,
  get: function get() {
    return _search.default;
  }
});
Object.defineProperty(exports, "service", {
  enumerable: true,
  get: function get() {
    return _service.default;
  }
});
Object.defineProperty(exports, "video", {
  enumerable: true,
  get: function get() {
    return _video.default;
  }
});
Object.defineProperty(exports, "window", {
  enumerable: true,
  get: function get() {
    return _window.default;
  }
});
var _image = _interopRequireDefault(require("@/assets/icons/page/components/image.svg?inline"));
var _banner = _interopRequireDefault(require("@/assets/icons/page/components/banner.svg?inline"));
var _article = _interopRequireDefault(require("@/assets/icons/page/components/article.svg?inline"));
var _navBar = _interopRequireDefault(require("@/assets/icons/page/components/navBar.svg?inline"));
var _notice = _interopRequireDefault(require("@/assets/icons/page/components/notice.svg?inline"));
var _search = _interopRequireDefault(require("@/assets/icons/page/components/search.svg?inline"));
var _video = _interopRequireDefault(require("@/assets/icons/page/components/video.svg?inline"));
var _window = _interopRequireDefault(require("@/assets/icons/page/components/window.svg?inline"));
var _goods = _interopRequireDefault(require("@/assets/icons/page/components/goods.svg?inline"));
var _service = _interopRequireDefault(require("@/assets/icons/page/components/service.svg?inline"));
var _guide = _interopRequireDefault(require("@/assets/icons/page/components/guide.svg?inline"));
var _richText = _interopRequireDefault(require("@/assets/icons/page/components/richText.svg?inline"));
var _blank = _interopRequireDefault(require("@/assets/icons/page/components/blank.svg?inline"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }